import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AbstractCoroutine2jzyhqo91sb0o as AbstractCoroutine } from '../AbstractCoroutine.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { recoverResult92pymwoef8np as recoverResult } from '../CompletionState.mjs';
import { resumeCancellableWithInternalk8vmvm2je8v0 as resumeCancellableWithInternal } from './DispatchedContinuation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ContextScopeClass;
function ContextScope() {
  if (ContextScopeClass === VOID) {
    class $ {
      constructor(context) {
        this.coroutineContext_1 = context;
      }
      get_coroutineContext_115oqo_k$() {
        return this.coroutineContext_1;
      }
      toString() {
        return 'CoroutineScope(coroutineContext=' + toString(this.coroutineContext_1) + ')';
      }
    }
    initMetadataForClass($, 'ContextScope');
    ContextScopeClass = $;
  }
  return ContextScopeClass;
}
var ScopeCoroutineClass;
function ScopeCoroutine() {
  if (ScopeCoroutineClass === VOID) {
    class $ extends AbstractCoroutine() {
      constructor(context, uCont) {
        super(context, true, true);
        this.uCont_1 = uCont;
      }
      get_isScopedCoroutine_rwmmff_k$() {
        return true;
      }
      afterCompletion_2p0irt_k$(state) {
        resumeCancellableWithInternal(intercepted(this.uCont_1), recoverResult(state, this.uCont_1));
      }
      afterCompletionUndispatched_mss5y2_k$() {
      }
      afterResume_ugh2hm_k$(state) {
        this.uCont_1.resumeWith_rk9gbt_k$(recoverResult(state, this.uCont_1));
      }
    }
    initMetadataForClass($, 'ScopeCoroutine', VOID, VOID, VOID, [0]);
    ScopeCoroutineClass = $;
  }
  return ScopeCoroutineClass;
}
//region block: exports
export {
  ContextScope as ContextScoper0znlsj7ufhq,
  ScopeCoroutine as ScopeCoroutine2c07fgm3ekmnx,
};
//endregion

//# sourceMappingURL=Scopes.mjs.map
